module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-breadcrumb', [_c('b-breadcrumb-item', {
    attrs: {
      "text": "Home",
      "to": "/"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "User Profile",
      "to": "/user/profile"
    }
  }), _vm._v(" "), _c('b-breadcrumb-item', {
    attrs: {
      "text": "Password",
      "active": true
    }
  })], 1), _vm._v(" "), _c('b-container', [_c('b-form', {
    on: {
      "submit": _vm.changePassword
    }
  }, [_c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "oldPassword-group",
      "label": "Current Password:",
      "label-for": "oldPassword",
      "description": "Enter your current password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "oldPassword",
      "type": "password",
      "autofocus": "",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.oldPassword),
      callback: function($$v) {
        _vm.oldPassword = $$v
      },
      expression: "oldPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "newPassword-group",
      "label": "New Password:",
      "label-for": "newPassword",
      "description": "Enter a new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "newPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "id": "verifyPassword-group",
      "label": "Verify Password:",
      "label-for": "verifyPassword",
      "description": "Re-enter new password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "verifyPassword",
      "type": "password",
      "required": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.verifyPassword),
      callback: function($$v) {
        _vm.verifyPassword = $$v
      },
      expression: "verifyPassword"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "type": "Submit",
      "variant": "primary"
    }
  }, [_vm._v("Update")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7018cd9a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/security/ChangePasswordPage.vue
// module id = 2144
// module chunks = 1